import Button from "@/components/atoms/Button";
import Sprite from "@/components/atoms/Sprite";
import { cn } from "@/helpers/className";
import { useTranslation } from "@/i18n/client";
import { AllowedLanguages } from "@/types/generic";

interface JobsRegisterCtaProps {
  locale: AllowedLanguages;
}

export const JobListCta = ({ locale }: JobsRegisterCtaProps) => {
  const { t } = useTranslation(locale);

  return (
    <div
      className={cn(
        "cta relative overflow-hidden rounded-lg bg-yellow-600 p-6 pb-5 lg:p-10 lg:pb-9",
      )}
    >
      <div className="relative z-1 grid grid-cols-12">
        <div className="col-span-12 lg:col-span-10">
          <h3>{t("jobs.cta.title")}</h3>
          <div className="mb-7 text-lg text-black-400">
            {t("jobs.cta.text")}
          </div>
          <Button as={"link"} className="btn-lg" href={t("jobs.cta.link")}>
            {t("jobs.cta.btn")}
          </Button>
        </div>
      </div>

      <Sprite className="cta__sprite bottom-[-484px] right-0 h-[1205px] w-[913px] translate-x-[600px] xl:translate-x-[456px]" />
    </div>
  );
};

export default JobListCta;
